/* eslint-disable no-console */

/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * APIs to talk with the browser.
 * This package could be used by any third-party project.
 */
export default class WebRTC {
  /**
   * Print stats to console.
   * @returns {undefined}
   */
  printStatsToConsole() {
    console.log('stats');
  }

  /**
   * Get history.
   * @returns {Object}
   */
  getHistory() {
    return {};
  }

  /**
   * Get info before analysis.
   * @returns {Object}
   */
  getRawInfo() {
    return {};
  }

  /**
   * Set peer connection and video.
   * TODO: Should this be split into explicit calls?
   * e.g., setPeerConnection, setVideo
   * @returns {undefined}
   */
  setPeerConnectionAndVideo() {}
}
